import { call, put, select } from 'redux-saga/effects';
import cirrusClient from '../../../services/api/cirrus-client';
import { showSnackbar } from '../../../state/snackbar/snackbarSlice';
import { selectUserCredentials } from '../../../state/userCredential/userCredentialSlice';
import { fetchContactAction } from '../fetchContact/action';

export function* updateContactSaga(action) {
    const { contactId } = action.payload;
    try {
        const { domain, user } = yield select(selectUserCredentials);
        const { contactId, ...contactData } = action.payload;
        console.log('This is the contactData', contactData)
        const params = {
            'name-first-name': contactData.first_name,
            'name-middle-name': '',  
            'name-last-name': contactData.last_name,
            'email': contactData.email,
            'company': contactData.group || '', 
            'phonenumber-work': contactData.work_phone || '', 
            'phonenumber-cell': contactData.cell_phone || '', 
            'phonenumber-fax': contactData.fax || '',
            'phonenumber-home': contactData.home_phone || '',  
        };
        const response = yield call(cirrusClient.put, `/v2/domains/${domain}/users/${user}/contacts/${contactId}`, params);
        if (response.data.code === 202) {
            yield put(fetchContactAction());
            yield put(showSnackbar({
                message: 'Contact updated successfully',
                severity: 'success'
            }));
        }
    } catch (error) {
        console.error('Error updating contact:', error);
        yield put(showSnackbar({
            message: 'Failed to update contact',
            severity: 'error'
        }));
    }
}